import { useCallback, useMemo } from 'react';
import moment from 'moment';
import Grid, { GridProps } from '@mui/material/Grid';
import { useField } from 'formik';
import { FormDatePicker } from '../DatePicker';

interface Props extends GridProps {
    nameFrom?: string;
    nameTo?: string;
}

export const FormDateRangePicker = ({ nameFrom = 'from', nameTo = 'to', ...props }: Props) => {
    const [fromField] = useField(nameFrom);
    const [toField, , helpers] = useField(nameTo);

    const changeDateFromHandler = useCallback(
        (newValue: string | null) => {
            if (newValue && moment(newValue).isAfter(moment(toField.value))) {
                helpers.setValue(newValue);
            }
        },
        [toField.value, helpers],
    );

    const maxDate = useMemo(() => moment(), []);

    return (
        <Grid container mb={1.5} {...props}>
            <Grid item xs={6} pr={0.5}>
                <FormDatePicker
                    allowEmpty
                    format="MM/DD/YYYY"
                    name="from"
                    label="From"
                    maxDate={maxDate}
                    onChangeCallback={changeDateFromHandler}
                />
            </Grid>
            <Grid item xs={6} pl={0.5}>
                <FormDatePicker
                    allowEmpty
                    format="MM/DD/YYYY"
                    name="to"
                    label="To"
                    minDate={moment(fromField.value)}
                    maxDate={maxDate}
                />
            </Grid>
        </Grid>
    );
};
